/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressFromJSON, AddressToJSON, } from './Address';
import { BadDrivingDetailsFromJSON, BadDrivingDetailsToJSON, } from './BadDrivingDetails';
import { BountyFromJSON, BountyToJSON, } from './Bounty';
import { BountyLocationFromJSON, BountyLocationToJSON, } from './BountyLocation';
import { CrashLinkStatusFromJSON, CrashLinkStatusToJSON, } from './CrashLinkStatus';
import { IncidentReportTypeFromJSON, IncidentReportTypeToJSON, } from './IncidentReportType';
import { LawEnforcementDetailsFromJSON, LawEnforcementDetailsToJSON, } from './LawEnforcementDetails';
import { ModerationStatusFromJSON, ModerationStatusToJSON, } from './ModerationStatus';
import { RoadRageDetailsFromJSON, RoadRageDetailsToJSON, } from './RoadRageDetails';
import { TrafficAccidentDetailsFromJSON, TrafficAccidentDetailsToJSON, } from './TrafficAccidentDetails';
import { UserIncidentFileFromJSON, UserIncidentFileToJSON, } from './UserIncidentFile';
import { UserIncidentFootageFromJSON, } from './UserIncidentFootage';
import { UserIncidentImageFromJSON, } from './UserIncidentImage';
import { UserProfileFromJSON, UserProfileToJSON, } from './UserProfile';
/**
 * Check if a given object implements the IncidentReport interface.
 */
export function instanceOfIncidentReport(value) {
    let isInstance = true;
    return isInstance;
}
export function IncidentReportFromJSON(json) {
    return IncidentReportFromJSONTyped(json, false);
}
export function IncidentReportFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (json['deletedAt'] === null ? null : new Date(json['deletedAt'])),
        'rowVersion': !exists(json, 'rowVersion') ? undefined : json['rowVersion'],
        'moderationStatus': !exists(json, 'moderationStatus') ? undefined : ModerationStatusFromJSON(json['moderationStatus']),
        'hasContentWarning': !exists(json, 'hasContentWarning') ? undefined : json['hasContentWarning'],
        'isFilmedInPublicLocation': !exists(json, 'isFilmedInPublicLocation') ? undefined : json['isFilmedInPublicLocation'],
        'userConsentProvided': !exists(json, 'userConsentProvided') ? undefined : json['userConsentProvided'],
        'openDataCrashId': !exists(json, 'openDataCrashId') ? undefined : json['openDataCrashId'],
        'crashLinkStatus': !exists(json, 'crashLinkStatus') ? undefined : CrashLinkStatusFromJSON(json['crashLinkStatus']),
        'crashLinkReviewedAt': !exists(json, 'crashLinkReviewedAt') ? undefined : (json['crashLinkReviewedAt'] === null ? null : new Date(json['crashLinkReviewedAt'])),
        'incidentReportType': !exists(json, 'incidentReportType') ? undefined : IncidentReportTypeFromJSON(json['incidentReportType']),
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'location': !exists(json, 'location') ? undefined : BountyLocationFromJSON(json['location']),
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'incidentDateTime': !exists(json, 'incidentDateTime') ? undefined : (new Date(json['incidentDateTime'])),
        'incidentTimezone': !exists(json, 'incidentTimezone') ? undefined : json['incidentTimezone'],
        'userSubmittedIncidentDescription': !exists(json, 'userSubmittedIncidentDescription') ? undefined : json['userSubmittedIncidentDescription'],
        'incidentDescription': !exists(json, 'incidentDescription') ? undefined : json['incidentDescription'],
        'userProfileId': !exists(json, 'userProfileId') ? undefined : json['userProfileId'],
        'userProfile': !exists(json, 'userProfile') ? undefined : UserProfileFromJSON(json['userProfile']),
        'createdBySubject': !exists(json, 'createdBySubject') ? undefined : json['createdBySubject'],
        'updatedBySubject': !exists(json, 'updatedBySubject') ? undefined : json['updatedBySubject'],
        'userIncidentFileCollection': !exists(json, 'userIncidentFileCollection') ? undefined : (json['userIncidentFileCollection'] === null ? null : json['userIncidentFileCollection'].map(UserIncidentFileFromJSON)),
        'primaryUserIncidentFileId': !exists(json, 'primaryUserIncidentFileId') ? undefined : json['primaryUserIncidentFileId'],
        'primaryUserIncidentFile': !exists(json, 'primaryUserIncidentFile') ? undefined : UserIncidentFileFromJSON(json['primaryUserIncidentFile']),
        'userIncidentFootageCollection': !exists(json, 'userIncidentFootageCollection') ? undefined : (json['userIncidentFootageCollection'] === null ? null : json['userIncidentFootageCollection'].map(UserIncidentFootageFromJSON)),
        'userIncidentImageCollection': !exists(json, 'userIncidentImageCollection') ? undefined : (json['userIncidentImageCollection'] === null ? null : json['userIncidentImageCollection'].map(UserIncidentImageFromJSON)),
        'badDrivingDetails': !exists(json, 'badDrivingDetails') ? undefined : BadDrivingDetailsFromJSON(json['badDrivingDetails']),
        'lawEnforcementDetails': !exists(json, 'lawEnforcementDetails') ? undefined : LawEnforcementDetailsFromJSON(json['lawEnforcementDetails']),
        'roadRageDetails': !exists(json, 'roadRageDetails') ? undefined : RoadRageDetailsFromJSON(json['roadRageDetails']),
        'trafficAccidentDetails': !exists(json, 'trafficAccidentDetails') ? undefined : TrafficAccidentDetailsFromJSON(json['trafficAccidentDetails']),
        'bountyId': !exists(json, 'bountyId') ? undefined : json['bountyId'],
        'bounty': !exists(json, 'bounty') ? undefined : BountyFromJSON(json['bounty']),
    };
}
export function IncidentReportToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'isDeleted': value.isDeleted,
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt === null ? null : value.deletedAt.toISOString()),
        'rowVersion': value.rowVersion,
        'moderationStatus': ModerationStatusToJSON(value.moderationStatus),
        'hasContentWarning': value.hasContentWarning,
        'isFilmedInPublicLocation': value.isFilmedInPublicLocation,
        'userConsentProvided': value.userConsentProvided,
        'openDataCrashId': value.openDataCrashId,
        'crashLinkStatus': CrashLinkStatusToJSON(value.crashLinkStatus),
        'crashLinkReviewedAt': value.crashLinkReviewedAt === undefined ? undefined : (value.crashLinkReviewedAt === null ? null : value.crashLinkReviewedAt.toISOString()),
        'incidentReportType': IncidentReportTypeToJSON(value.incidentReportType),
        'countryCode': value.countryCode,
        'location': BountyLocationToJSON(value.location),
        'address': AddressToJSON(value.address),
        'incidentDateTime': value.incidentDateTime === undefined ? undefined : (value.incidentDateTime.toISOString()),
        'incidentTimezone': value.incidentTimezone,
        'userSubmittedIncidentDescription': value.userSubmittedIncidentDescription,
        'incidentDescription': value.incidentDescription,
        'userProfileId': value.userProfileId,
        'userProfile': UserProfileToJSON(value.userProfile),
        'createdBySubject': value.createdBySubject,
        'updatedBySubject': value.updatedBySubject,
        'userIncidentFileCollection': value.userIncidentFileCollection === undefined ? undefined : (value.userIncidentFileCollection === null ? null : value.userIncidentFileCollection.map(UserIncidentFileToJSON)),
        'primaryUserIncidentFileId': value.primaryUserIncidentFileId,
        'primaryUserIncidentFile': UserIncidentFileToJSON(value.primaryUserIncidentFile),
        'badDrivingDetails': BadDrivingDetailsToJSON(value.badDrivingDetails),
        'lawEnforcementDetails': LawEnforcementDetailsToJSON(value.lawEnforcementDetails),
        'roadRageDetails': RoadRageDetailsToJSON(value.roadRageDetails),
        'trafficAccidentDetails': TrafficAccidentDetailsToJSON(value.trafficAccidentDetails),
        'bountyId': value.bountyId,
        'bounty': BountyToJSON(value.bounty),
    };
}
